import { render } from "./HelpTooltip.vue?vue&type=template&id=535966c8&scoped=true"
import script from "./HelpTooltip.vue?vue&type=script&lang=js"
export * from "./HelpTooltip.vue?vue&type=script&lang=js"

import "./HelpTooltip.vue?vue&type=style&index=0&id=535966c8&scoped=true&lang=css"

import exportComponent from "/Users/sivasankarelango/Sivasankar/cx-portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-535966c8"]])

export default __exports__